module.exports = __webpack_public_path__ + "img/dream2.4f51c875.png";